import { render } from "./CommonMessagesChart.vue?vue&type=template&id=06700f46&scoped=true"
import script from "./CommonMessagesChart.vue?vue&type=script&lang=js"
export * from "./CommonMessagesChart.vue?vue&type=script&lang=js"

import "./CommonMessagesChart.vue?vue&type=style&index=0&id=06700f46&lang=scss&scoped=true"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06700f46"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpinner});
